import { HelmetInfo, DisambiguationOption, ValidationResult } from '../../types/helmetLookup'
import { createPlayerName } from './validation'

// Raw feature values from the API are not display-friendly (e.g. 'sf-echo')
export const formatFeatures = (features?: string | null): string => {
  if (!features) {
    return ''
  }

  return features.toLowerCase() === 'sf-echo' ? 'SF Echo' : features
}

export const mapToDisambiguationOption = (helmet: any, watchedHelmetId: string): DisambiguationOption => ({
  helmetId: helmet.helmetId || watchedHelmetId,
  organization: helmet.sourceOrgName || helmet.orgName,
  playerName: helmet.currentPlayer?.playerName || (helmet.firstName && helmet.lastName ? createPlayerName(helmet) : undefined),
  jerseyNumber: helmet.currentPlayer?.jerseyNumber || (helmet.firstName?.toUpperCase() !== 'RIDDELL' ? helmet.jerseyNumber : undefined),
  playerUnitID: helmet.playerUnitID,
  playerUnitSerial: helmet.playerUnitSerialString,
  playerUnitFirmwareVersion: helmet.playerUnitFirmwareVersion,
  playerUnitFirmwareVersionSemVer: helmet.playerUnitFirmwareVersionSemVer || '',
  playerUnitHardwareNumber: helmet.playerUnitHardwareNumber || 0,
  helmetRFIDLabel: helmet.helmetRFIDLabel,
  rfidCode: helmet.rfidCode,
  rfidBarcode: helmet.rfidBarcode,
  sourceOrgID: helmet.sourceOrgID || helmet.orgID,
  sourceOrgName: helmet.sourceOrgName || helmet.orgName,
  sourceTeamID: helmet.sourceTeamID || helmet.teamID,
  originalMaterialNo: helmet.originalMaterialNo,
  helmetHatSize: helmet.helmetHatSize,
  features: helmet.features,
  shell: helmet.shell,
  shellColor: helmet.shellColor,
  colorCode: helmet.colorCode,
  paintCode1: helmet.paintCode1,
  paintCode1Description: helmet.paintCode1Description,
  paintCode2: helmet.paintCode2,
  paintCode2Description: helmet.paintCode2Description,
  helmetType: helmet.helmetType,
  helmetColor: helmet.helmetColor,
  paintDesignCode: helmet.paintDesignCode,
  paintDesignDescription: helmet.paintDesignDescription,
  helmet_config_id: helmet.helmet_config_id
})

export const mapToHelmetInfo = (
  raw: any,
  watchedHelmetId: string,
  validationResult: ValidationResult
): HelmetInfo => {
  const isBarcodeLike = /^NC\d+$/i.test(watchedHelmetId)

  return {
    helmetId: raw.helmetId || watchedHelmetId,
    playerUnitID: raw.playerUnitID,
    playerUnitSerialString: raw.playerUnitSerialString,
    playerUnitFirmwareVersion: raw.playerUnitFirmwareVersion,
    playerUnitFirmwareVersionSemVer: raw.playerUnitFirmwareVersionSemVer || '',
    playerUnitHardwareNumber: raw.playerUnitHardwareNumber || 0,
    sourceOrgID: raw.sourceOrgID || raw.orgID,
    sourceOrgName: raw.sourceOrgName || raw.orgName,
    sourceTeamID: raw.sourceTeamID || raw.teamID,
    currentPlayer: raw.currentPlayer || (raw.lastName && raw.firstName ? {
      playerName: createPlayerName(raw),
      jerseyNumber: raw.firstName.toUpperCase() !== 'RIDDELL' ? raw.jerseyNumber : undefined
    } : undefined),
    helmetRFIDLabel: raw.helmetRFIDLabel || (validationResult.type === 'rfidLabel' ? watchedHelmetId : undefined),
    rfidBarcode: raw.rfidBarcode || (validationResult.type === 'rfidCode' ? watchedHelmetId : undefined),
    rfidCode: raw.rfidCode || (validationResult.type === 'rfidCode' && !isBarcodeLike ? watchedHelmetId : undefined),
    jerseyNumber: raw.jerseyNumber,
    originalMaterialNo: raw.originalMaterialNo,
    helmetHatSize: raw.helmetHatSize,
    features: raw.features,
    shell: raw.shell,
    shellColor: raw.shellColor,
    colorCode: raw.colorCode,
    paintCode1: raw.paintCode1,
    paintCode1Description: raw.paintCode1Description,
    paintCode2: raw.paintCode2,
    paintCode2Description: raw.paintCode2Description,
    helmetType: raw.helmetType,
    helmetColor: raw.helmetColor,
    paintDesignCode: raw.paintDesignCode,
    paintDesignDescription: raw.paintDesignDescription,
    helmet_config_id: raw.helmet_config_id
  }
}

export const mapDisambiguationToHelmetInfo = (
  option: DisambiguationOption,
  watchedHelmetId: string,
  validationResult: ValidationResult
): HelmetInfo => {
  const isBarcodeLike = /^NC\d+$/i.test(watchedHelmetId)

  return {
    helmetId: option.helmetId,
    playerUnitID: option.playerUnitID,
    playerUnitSerialString: option.playerUnitSerial,
    playerUnitFirmwareVersion: option.playerUnitFirmwareVersion,
    playerUnitFirmwareVersionSemVer: option.playerUnitFirmwareVersionSemVer,
    playerUnitHardwareNumber: option.playerUnitHardwareNumber,
    sourceOrgID: option.sourceOrgID,
    sourceOrgName: option.sourceOrgName,
    sourceTeamID: option.sourceTeamID,
    currentPlayer: option.playerName ? {
      playerName: option.playerName,
      jerseyNumber: option.jerseyNumber || ''
    } : undefined,
    helmetRFIDLabel: option.helmetRFIDLabel || (validationResult.type === 'rfidLabel' ? option.helmetId : undefined),
    rfidBarcode: option.rfidBarcode || (validationResult.type === 'rfidCode' ? option.helmetId : undefined),
    rfidCode: option.rfidCode || (validationResult.type === 'rfidCode' && !isBarcodeLike ? option.helmetId : undefined),
    originalMaterialNo: option.originalMaterialNo,
    helmetHatSize: option.helmetHatSize,
    features: option.features,
    shell: option.shell,
    shellColor: option.shellColor,
    colorCode: option.colorCode,
    paintCode1: option.paintCode1,
    paintCode1Description: option.paintCode1Description,
    paintCode2: option.paintCode2,
    paintCode2Description: option.paintCode2Description,
    helmetType: option.helmetType,
    helmetColor: option.helmetColor,
    paintDesignCode: option.paintDesignCode,
    paintDesignDescription: option.paintDesignDescription,
    helmet_config_id: option.helmet_config_id
  }
}
